import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CartMaster } from '../model/CartMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { OfferMaster } from '../model/OfferMaster.model';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import {MessageService} from 'primeng/api';
import { PredefinedMaster } from '../model/PredefinedMaster.model';
import { PaymentIntegration } from '../model/PaymentIntegration.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {

  cartMaster:CartMaster=new CartMaster()
  courseList:CourseMaster[]=[]
  studentMaster:StudentMaster=new StudentMaster()
  recieptMaster:ReceiptMaster=new ReceiptMaster();
  offerMaster:OfferMaster=new OfferMaster();
  cartMasterList:CartMaster[]=[]
  predefinedMaster:PredefinedMaster[]=[]
  showDialogSuccess: boolean=false;
  showDialogFailure: boolean=false;
  value: boolean=false;
  tempModel:any;
  paymentStatus: string = "";
  recieptMasterTemp:ReceiptMaster=new ReceiptMaster();
  couponApplied:boolean=false;

  paymentIntegration:PaymentIntegration= new PaymentIntegration();

  constructor(private authService:AuthService,public  activater:ActivatedRoute,private router:Router,private mainService:MainserviceService,private messageService: MessageService) { }

  ngOnInit() {


    this.activater.params.subscribe( params => {    
      this.paymentStatus =  params.string;
    });
    this.recieptMasterTemp=this.authService.getRecieptSession();

    if(this.paymentStatus == "failure"){
      this.viewDialogFailure();
      this.authService.setRecieptSession(null);
      // this.router.navigateByUrl('/payment-confirmation/failure'); 
    }
    if(this.paymentStatus == "success"){
      this.viewDialogSuccess();
      this.authService.setRecieptSession(null);
      // this.router.navigateByUrl('/payment-confirmation/success'); 
    }

   
    this.courseList=this.authService.getcourseListSession(); 

    if(this.courseList == null) {
      // setTimeout(() => {
      //   this.router.navigateByUrl('/student-dashboard'); 
      // }, 2000);
    }

    this.studentMaster = this.authService.getUserSession();
    
if(this.courseList != null && this.courseList.length > 0){
    this.courseList.forEach(course => {
      
      course.courseLanguagePredefinedMasterListTemp = [];

      course.courseLanguageMasterList.forEach(courseLanguageMaster => {
        
        course.courseLanguagePredefinedMasterListTemp.push(courseLanguageMaster.predefinedMaster);

      });


      if(course.courseLanguageMasterList.length > 0) {
        course.languageTemp = course.courseLanguageMasterList[0].predefinedMaster;
      }

    });

  }

    this.getBifurcationAmount();
    // this.getCartList(this.studentMaster);
  }

  // getCartList(studentMaster:StudentMaster){
  
   
  //   this.cartMaster.studentMaster = new StudentMaster();
  //   let student=this.authService.getUserSession();
  //   this.cartMaster.studentMaster.studentMasterId = student.studentMasterId;
    
  //   this.mainService.getCartMasterList(this.cartMaster).subscribe(data=>{
  //     this.cartMasterList = data;
  //   })
  
  // }


  getBifurcationAmount() {

    

   this.recieptMaster.courseMasterList=this.courseList;
   
    
    this.mainService.getReceiptBifurcationAmount(this.recieptMaster).subscribe(
      (data) => {
        this.recieptMaster = data;
        // this.resetTicks();
        this.recieptMaster.offer=new OfferMaster();
        
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  applyCouponCode(){

    
    this.recieptMaster.offer = this.offerMaster;
    
    this.mainService.applyCouponCode(this.recieptMaster).subscribe(
      (data) => {
        this.recieptMaster = data;
        this.couponApplied=true;
        
        if(this.recieptMaster.offer.errormsg=='COUPON-APPLIED'){
          this.messageService.add({severity:'success', summary:'Coupon code Applied!', detail:''});

        }
        else if(this.recieptMaster.offer.errormsg=='INVALID-COUPON'){
          this.messageService.add({severity:'error', summary:'Invalid Coupon code!', detail:''});

        }
        
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );

    
  }

  payForOrder(){

    this.recieptMaster.courseMasterList=this.courseList;

    let studentMasterTemp = new StudentMaster();
    studentMasterTemp.studentMasterId = this.studentMaster.studentMasterId;
    this.recieptMaster.studentMaster = studentMasterTemp;

    if(this.recieptMaster.offer != null && this.recieptMaster.offer.offerId == null) {
      this.recieptMaster.offer = null;
    }

   
    this.mainService.payForOrder(this.recieptMaster).subscribe(
      (data) => {
         this.paymentIntegration = data;
        // this.paymentSuccess(this.recieptMaster);

         this.authService.setRecieptSession({amount : this.recieptMaster.amount});

      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );

  }

  
  paymentSuccess(recieptMaster:ReceiptMaster){

    this.mainService.paymentSuccess(recieptMaster).subscribe(
      (data) => {
        this.authService.setcourseListSession(null);
        this.router.navigateByUrl('/payment-confirmation/success'); 
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );

  }

  viewDialogSuccess(){
      this.showDialogSuccess=true;
      // setTimeout(() => {
      //   this.authService.setRecieptSession(null);
      // }, 2000);
      
  }

  viewDialogFailure(){
    this.showDialogFailure=true;
    // setTimeout(() => {
    //   this.authService.setRecieptSession(null);
    // }, 2000);

}

  showTick(){
    document.getElementById('tick').style.display='block'
  }

  resetTicks(){
    if(this.recieptMaster.offer!=null && this.recieptMaster.offer.errormsg!=null){
      this.recieptMaster.offer=new OfferMaster();
      this.getBifurcationAmount();
      
      }
      
  }

  

}
